/*
 Create by smg  2015-12-25
 */
"use strict";
angular.module('editLayoutManageModule', ['batchOperationframeModule'])
    .controller('newsEditLayoutManageCtrl', editLayoutManage);
editLayoutManage.$injector = ["$scope", "$q", "$filter", "$timeout", "$modal", "$state", "$location", "$stateParams", "trsHttpService", "modalDialog", "myManuscriptService", 'initSingleSelecet', 'editingCenterService', 'trsspliceString', "initVersionService", "getNewsNameService", "productMangageMentNewspaperService"];

function editLayoutManage($scope, $q, $filter, $timeout, $modal, $state, $location, $stateParams, trsHttpService, modalDialog, myManuscriptService, initSingleSelecet, editingCenterService, trsspliceString, initVersionService, getNewsNameService, productMangageMentNewspaperService) {
    initStatus();
    initData();
    /**
     * [getSiteRights description]获取每个站点的操作权限
     * @return null [description]
     */
    function getSiteRights() {
        productMangageMentNewspaperService.getRight($stateParams.paper, "", "papersetpaper").then(function(data) {
            $scope.status.right = data;
        });
    }
    //下一页
    //类型筛选
    $scope.queryByPaperType = function() {
        $scope.params.Status = angular.copy($scope.newspaperManageStateSelected).value;
        if ($scope.params.Status == '') delete $scope.params.Status;
        requestData();
    };
    $scope.pageChanged = function() {
        $scope.params.CurrPage = $scope.page.CURRPAGE;
        $scope.copyCurrPage = $scope.page.CURRPAGE;
        requestData();
    };
    //点击分发配置管理，跳转
    // $scope.goDistributeConfig = function(SITEID) {
    //     $state.go("manageconfig.productmanage.newspaper.distributeconfig", {
    //         "paper": SITEID
    //     });
    // };
    //点击照排版面,判断该报纸下是否存在叠次
    /*$scope.goZPLayout = function(item) {
        if (item.ISZHAOPAI == 0) return;
        var params = {
            "serviceid": "mlf_paperset",
            "methodname": "queryDieCis",
            "PaperId": item.SITEID
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
            if (data.length < 1) {
                modalDialog.alertType("请先在该报纸下启用或添加叠次", "", "warning", false);
            } else {
                $state.go("manageconfig.productmanage.newspaper.typesettingpage", {
                    "paper": item.SITEID
                });
            }
        });
    };*/
    //搜索采编
    $scope.searchCaiBian = function() {
        $scope.params.ChnlDesc = $scope.keywords;
        requestData();
    };
    //跳转指定页面
    $scope.jumpToPage = function() {
        if ($scope.copyCurrPage > $scope.page.PAGECOUNT) {
            $scope.copyCurrPage = $scope.page.PAGECOUNT;
        }
        $scope.params.CurrPage = $scope.copyCurrPage;
        requestData();
        $scope.selectedArray = [];
    };

    //全选
    $scope.selectAll = function() {
        $scope.selectedArray = $scope.selectedArray.length == $scope.items.length ? [] : [].concat($scope.items);
    };

    //单选
    $scope.selectDoc = function(item) {
        //item.selected ? $scope.selectedArray.push(item) : $scope.selectedArray.splice($scope.selectedArray.indexOf(item), 1);
        if ($scope.selectedArray.indexOf(item) < 0) {
            $scope.selectedArray.push(item);
        } else {
            $scope.selectedArray.splice($scope.selectedArray.indexOf(item), 1);
        }
    };

    function getDropDown() {
        //停用启用
        $scope.newspaperManageState = initSingleSelecet.newspaperManageState();
        $scope.newspaperManageStateSelected = angular.copy($scope.newspaperManageState[0]);
    }

    //初始化状态
    function initStatus() {
        $scope.params = {
            "serviceid": "mlf_paperset",
            "methodname": "queryCaiBianBanMians",
            "PaperId": $stateParams.paper
        };
        $scope.status = {
            isTab: $location.path().split("/")[4],
            item: '',
            right: {},
            batchOperateBtn: {
                "hoverStatus": "",
                "clickStatus": ""
            },
        };
        $scope.selectedArray = [];
        getNewsNameService.getNewsName($stateParams.paper).then(function(data) {
            $scope.status.item = data;
            $scope.channelName = data.SITEDESC;
        });
        getSiteRights();
        $scope.copyCurrPage = 1;
    }

    //初始化数据
    function initData() {
        requestData();
        getDropDown();
        dieciDroplist();
        initClassifyDroplist();
    }

    function requestData(callback) {
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
            if (angular.isFunction(callback)) {
                callback(data);
            } else {
                $scope.items = data.DATA;
                $scope.page = data.PAGER;
                angular.isDefined($scope.page) ? $scope.page.PAGESIZE =
                    $scope.page.PAGESIZE.toString() : $scope.page = {
                        "PAGESIZE": 0,
                        "ITEMCOUNT": 0
                    };
            }
            $scope.selectedArray = [];
        });
    }


    //新建采编版面
    $scope.newpageediting = function() {
        draftSaveCreate();
    };
    //编辑采编版面
    $scope.editName = function(item) {
        if (angular.isDefined($scope.status.right.caibianbanmian.bianji)) {
            var modalInstance = $modal.open({
                templateUrl: "./manageConfig/productManageMent/newspaper/alertViews/editName/editName_tpl.html",
                scope: $scope,
                windowClass: 'bm-creat-edit-window',
                backdrop: false,
                controller: "productManageMentEditNameCtrl",
                resolve: {
                    selectedItem: function() {
                        return item;
                    }
                }
            });
            modalInstance.result.then(function() {
                requestData();
            });
        } else {
            modalDialog.alertType("您没有权限编辑该版面", "您没有权限编辑该版面", "error", false);
        }
    };

    function draftSaveCreate(returnData) {
        var modalInstance = $modal.open({
            templateUrl: "./manageConfig/productManageMent/newspaper/alertViews/editName/editName_tpl.html",
            scope: $scope,
            windowClass: 'bm-creat-edit-window',
            backdrop: false,
            controller: "productManageMentNewPageEditingCtrl",
            resolve: {
                params: function() {
                    return {
                        dieci: returnData ? returnData.dieci : "",
                        banmian: returnData ? returnData.banmian : "",
                        jianchen: returnData ? returnData.jianchen : ""
                    };
                }
            }
        });
        modalInstance.result.then(function(result) {
            delete result.banmian;
            delete result.jianchen;
            requestData(result);
            if (result != "save") {
                draftSaveCreate(result);
            }
        });
    }
    //版面排序
    $scope.layoutRank = function() {
        var selection = $scope.selectedArray[0];
        for (var s = 0; s < $scope.items.length; s++) {
            if (selection.CHANNELID == $scope.items[s].CHANNELID) {
                var curP = s;
                break;
            }
        };
        $scope.list = {
            oldPosition: curP + 1,
            curItemName: selection.CHNLDESC,
            allCounts: $scope.items.length,
            objId: selection.CHANNELID,
            objType: 101
        };
        productMangageMentNewspaperService.commOrder($scope.list, function() {
            $scope.params.serviceid = "mlf_paperset";
            $scope.params.methodname = "queryCaiBianBanMians";
            $scope.params.PaperId = $stateParams.paper;
            //$scope.params.DieCiId = result.value;
            //$scope.dieciDroplistSelected = result;
            requestData();
        });

    };




    //删除方法
    function deleteFun(item) {
        // $scope.params.serviceid = "mlf_paperset";
        // $scope.params.methodname = "deleteDieCiOrBanMians";
        // $scope.params.ObjectIds = item;
        // requestData(function() {
        //     $scope.params.serviceid = "mlf_paperset";
        //     $scope.params.methodname = "queryCaiBianBanMians";
        //     requestData();
        // });
        var params = {
            serviceid: 'mlf_paperset',
            methodname: 'deleteDieCiOrBanMians',
            ObjectIds: item,
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function() {
            requestData();
        }, function() {
            requestData();
        });
    }

    //单个删除
    $scope.singleDelete = function(item) {
        modalDialog.confirmModal('提示信息', "确认删除?", function() {
            deleteFun(item.CHANNELID);
        });
    };

    //批量删除
    $scope.batchDelete = function() {
        var items = trsspliceString.spliceString($scope.selectedArray,'CHANNELID', ',');
        modalDialog.confirmModal('提示信息', "确认删除?", function() {
            deleteFun(items);
        });
        // var modalInstance = $modal.open({
        //     templateUrl: "./manageConfig/productManageMent/newspaper/alertViews/batchDel/batchDel_tpl.html",
        //     windowClass: "batchDelClass",
        //     backdrop: false,
        //     controller: "productManageMentBatchDelCtrl",
        //     resolve: {
        //         delItems: function() {
        //             return $scope.selectedArray;
        //         },
        //         title: function() {
        //             return "您确认批量删除以下版面：";
        //         }
        //     }
        // });
        // modalInstance.result.then(function() {
        //     var delArray = trsspliceString.spliceString($scope.selectedArray,
        //         'CHANNELID', ',');
        //     deleteFun(delArray);
        // });
    };

    //停用启用
    $scope.stopOrStart = function(item) {
        modalDialog.confirmModal('提示信息', "确定" + (item.STATUS === "-1" ? "启用？" : "停用？"), function() {
            //启用
            if (item.STATUS === "-1") {
                $scope.params.serviceid = "mlf_paperset";
                $scope.params.methodname = "startDieCiOrBanMian";
                $scope.params.ObjectId = item.CHANNELID;
                requestData(function() {
                    $scope.params.serviceid = "mlf_paperset";
                    $scope.params.methodname = "queryCaiBianBanMians";
                    requestData();
                });
            }
            //停用
            if (item.STATUS == "0") {
                $scope.params.serviceid = "mlf_paperset";
                $scope.params.methodname = "stopDeiCiOrBanMian";
                $scope.params.ObjectId = item.CHANNELID;
                requestData(function() {
                    $scope.params.serviceid = "mlf_paperset";
                    $scope.params.methodname = "queryCaiBianBanMians";
                    requestData();
                });
            }
        });
    };
    /**
     * [batchOperation 批量操作启用或停用]
     * @return {[type]} [description]
     */
    $scope.batchOperation = function(sors) {
        var obj = trsspliceString.spliceString($scope.selectedArray, 'CHANNELID', ',');
        var sItemName = trsspliceString.spliceString($scope.selectedArray, 'CHNLDESC', '、');
        var aStatus = trsspliceString.spliceString($scope.selectedArray, 'STATUS', ',');
        var params = {
            "serviceid": "mlf_paperset",
            "ObjectIds": obj
        };
        var sTitle = "";
        if (sors) {
            if (aStatus.indexOf("-1") < 0) {
                modalDialog.alertType('请选择停用状态的面板', "", "warning", false, function() {
                    $scope.selectedArray = [];
                });
                return;
            }
            params.methodname = "startDieCisOrBanMians";
            sTitle = "启用";
        } else if (!sors) {
            if (aStatus.indexOf("0") < 0) {
                modalDialog.alertType('请选择启用状态的面板', "", "warning", false, function() {
                    $scope.selectedArray = [];
                });
                return;
            }
            params.methodname = "stopDeiCisOrBanMians";
            sTitle = "停用";
        } else {
            return;
        }
        batchOperationWindow(params, sTitle, sItemName);
    };
    /**
     * [batchOperationWindow 启用/停用弹窗]
     * @param  {[Obj]} param   [请求参数]
     * @param  {[type]} title   [提示内容标题]
     * @param  {[type]} content [提示内容]
     * @return {[type]}         [description]
     */
    function batchOperationWindow(params, title, content) {
        var modalInstance = $modal.open({
            templateUrl: "./manageConfig/productManageMent/newspaper/service/batchOperation/batchOperation_tpl.html",
            windowClass: 'batch-Operation',
            backdrop: true,
            controller: "batchOperationframeCtrl",
            resolve: {
                sTitle: function() {
                    return title;
                },
                sContent: function() {
                    return content;
                }
            },
        });
        modalInstance.result.then(function() {
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                requestData();
                $scope.selectedArray = [];
            }, function(data) {
                requestData();
            });
        });
    }
    //初始化叠次下拉框
    function dieciDroplist() {
        var deffered = $q.defer();
        var params = {
            "serviceid": "mlf_paperset",
            "methodname": "queryDieCis",
            "PaperId": $stateParams.paper
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
            var dieciDroplistJson = data;
            var options = [];
            options.push({
                "name": "全部叠次",
                "value": ""
            });
            for (var key in dieciDroplistJson) {
                options.push({
                    name: dieciDroplistJson[key].CHNLDESC,
                    value: dieciDroplistJson[key].CHANNELID
                });
            }
            $scope.dieciDroplistJson = options;
            $scope.dieciDroplistSelected = angular.copy($scope.dieciDroplistJson[0]);
            $scope.params.DieCiId = $scope.dieciDroplistSelected.value;
            deffered.resolve();
        });
        return deffered.promise;
    }
    $scope.getDieciData = function() {
        $scope.params.serviceid = "mlf_paperset";
        $scope.params.methodname = "queryCaiBianBanMians";
        $scope.params.PaperId = $stateParams.paper;
        $scope.params.DieCiId = $scope.dieciDroplistSelected.value;
        requestData();
    };
    //初始化分类下拉框
    function initClassifyDroplist() {
        var deffered = $q.defer();
        var params = {
            "serviceid": "mlf_paperset",
            /*"methodname": "queryCaiBianCategory",*/
            "methodname": "queryCaiBianCategoryWithoutRight",
            "PaperId": $stateParams.paper
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
            var classifyDroplistJson = data;
            var options = [];
            options.push({
                "name": "全部分类",
                "value": ""
            });
            for (var key in classifyDroplistJson) {
                options.push({
                    name: classifyDroplistJson[key].CATEGORYNAME,
                    value: classifyDroplistJson[key].CAIBIANCATEGORYID
                });
            }
            $scope.classifyDroplistJson = options;
            $scope.classifyDroplistSelected = angular.copy($scope.classifyDroplistJson[0]);
            $scope.params.CategoryId = $scope.classifyDroplistSelected.value;
            deffered.resolve();
        });
        return deffered.promise;
    }
    //按分类查询
    $scope.getClassifyData = function() {
        $scope.params.serviceid = "mlf_paperset";
        $scope.params.methodname = "queryCaiBianBanMians";
        $scope.params.PaperId = $stateParams.paper;
        $scope.params.CategoryId = $scope.classifyDroplistSelected.value;
        requestData();
    };
    //点击采编分类，跳转
    $scope.goClassifyLayout = function() {
        $state.go("manageconfig.productmanage.newspaper.typeclassifysettingpage", {
            "paper": $stateParams.paper
        });
    };
}